export const interpolateEndpoint = (endpoint, context) => {
    console.log('interpolating', endpoint, 'with', context);
    if (!context) {
        context = {};
    }
    return Object.keys(context).reduce((result, key) => {
        console.log('key', key);
        console.log('value', context[key]);
        const value = context[key].replaceAll('/[^a-zA-Z0-9-_]/', ''); // remove anything that isn't valid in a URL slug
        console.log('clean value', value);
        result = result.replaceAll('{' + key + '}', value);
        console.log('interpolated result', result);
        return result;
    }, endpoint);
};